import { cbi_extraction_state_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiExtractionStateEnum = (enumValue: cbi_extraction_state_enum) => {
  switch (enumValue) {
    case cbi_extraction_state_enum.AUTOMATIC_APPROVAL:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-AUTOMATIC_APPROVAL" />;
    case cbi_extraction_state_enum.AUTOMATIC_REJECTION:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-AUTOMATIC_REJECTION" />;
    case cbi_extraction_state_enum.FAILED:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-FAILED" />;
    case cbi_extraction_state_enum.MANUAL_APPROVAL:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-MANUAL_APPROVAL" />;
    case cbi_extraction_state_enum.MANUAL_REJECTION:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-MANUAL_REJECTION" />;
    case cbi_extraction_state_enum.NEEDS_REVIEW:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-NEEDS_REVIEW" />;
    case cbi_extraction_state_enum.PENDING:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-PENDING" />;
    case cbi_extraction_state_enum.RUNNING:
      return <Trans i18nKey="Enum_CbiExtractionStateEnum-RUNNING" />;
  }
};

export const translateCbiExtractionStateEnum_dynamic = (enumValue: cbi_extraction_state_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_extraction_state_enum.AUTOMATIC_APPROVAL:
      return t('Enum_CbiExtractionStateEnum-AUTOMATIC_APPROVAL');
    case cbi_extraction_state_enum.AUTOMATIC_REJECTION:
      return t('Enum_CbiExtractionStateEnum-AUTOMATIC_REJECTION');
    case cbi_extraction_state_enum.FAILED:
      return t('Enum_CbiExtractionStateEnum-FAILED');
    case cbi_extraction_state_enum.MANUAL_APPROVAL:
      return t('Enum_CbiExtractionStateEnum-MANUAL_APPROVAL');
    case cbi_extraction_state_enum.MANUAL_REJECTION:
      return t('Enum_CbiExtractionStateEnum-MANUAL_REJECTION');
    case cbi_extraction_state_enum.NEEDS_REVIEW:
      return t('Enum_CbiExtractionStateEnum-NEEDS_REVIEW');
    case cbi_extraction_state_enum.PENDING:
      return t('Enum_CbiExtractionStateEnum-PENDING');
    case cbi_extraction_state_enum.RUNNING:
      return t('Enum_CbiExtractionStateEnum-RUNNING');
  }
};
